<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="
            d-flex
            align-items-center
            justify-content-between
          ">
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>

          <div class="page-title-right">
            <b-button v-b-modal.modal-lg variant="primary" @click="closeModal">
              <b>Nouveau</b>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12" style="padding-bottom: 100px">
        <b-modal id="modal-lg" v-model="showModal" size="md" centered :title="modalTitle" title-class="font-18"
          hide-footer>
          <form @submit.prevent="onSubmit" v-if="!updating">
            <div class="row">
              <div class="col">
                <label>{{ $t("pages.groups.table.name") }} </label>
                <input type="text" v-model.trim="group.name" class="form-control" required />
              </div>
            </div>
            <div class="row mt-4 mb-12">
              <div class="col">
                <label>{{ $t("pages.groups.table.description") }} </label>
                <textarea class="form-control" v-model.trim="group.description" required />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12 text-left">
                <br />
                <button type="submit" v-if="this.isLoading === false" class="btn col-4 btn-primary mr-2">
                  {{ $t("pages.metadata.save") }}
                </button>
                <button class="btn btn-primary mr-2" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{ $t("pages.metadata.saving") }}
                </button>
                <button type="button" class="btn btn-light" @click="closeModal" data-dismiss="modal">
                  {{ $t("pages.metadata.cancel") }}
                </button>
              </div>
            </div>
          </form>
          <form @submit.prevent="onSubmit" v-else>
            <div class="row mt-4">
              <div class="col">
                <label>{{ $t("pages.groups.table.name") }} </label>
                <input type="text" v-model.trim="selectedItem.name" class="form-control" required
                  :placeholder="$t(name_placeholder)" />
              </div>
            </div>
            <div class="row mt-4 mb-12">
              <div class="col">
                <label>{{ $t("pages.groups.table.description") }} </label>
                <textarea class="form-control" v-model.trim="selectedItem.description"
                  :placeholder="$t(description_placeholder)" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-left">
                <hr />
                <button type="submit" v-if="this.isLoading === false" class="btn btn-primary mr-2">
                  {{ $t("pages.metadata.save") }}
                </button>
                <button class="btn btn-primary mr-2" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{ $t("pages.metadata.saving") }}
                </button>
                <button type="button" class="btn btn-light" @click="closeModal" data-dismiss="modal">
                  {{ $t("pages.metadata.cancel") }}
                </button>
              </div>
            </div>
          </form>
        </b-modal>
        <div v-if="isLoading" class="mt-2">
          <b-skeleton-table :rows="6" :columns="4"></b-skeleton-table>
        </div>
        <div class="row" v-else-if="groups.length > 0">
          <div class="col-12 col-md-6 d-block d-lg-none"  v-for="group in pageOfItems" :key="group.id">
            <b-card class="border">
              <b-dropdown class="card-drop float-right" variant="white" right toggle-class="p-0">
                <template v-slot:button-content>
                  <i class="mdi mdi-dots-vertical font-size-18"></i>
                </template>
                <b-dropdown-item @click="
                                $router.push({ path: `/groups/show/${group.id}` })
                            ">
                  {{ $t("pages.users.display") }}
                </b-dropdown-item>
                <b-dropdown-item @click="updateGroupModal(group)">
                  {{ $t("pages.metadata.edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="onDelete(group)">
                  {{ $t("pages.users.delete") }}
                </b-dropdown-item>
              </b-dropdown>
              
              <b-card-title>
                {{ group.name }}
              </b-card-title>

              <b-card-text>{{ group.description }}</b-card-text>

              <b-card-text class="small text-muted">{{ $d(new Date(group.created_at), 'short') }}</b-card-text>
            </b-card>
          </div>
          <div class="col-12 d-none d-lg-table">
            <table class="table table-hover">
              <thead class="thead-light">
                <tr>
                  <th>{{ $t("pages.groups.table.name") }}</th>
                  <th>{{ $t("pages.groups.table.description") }}</th>
                  <th>{{ $t("pages.groups.table.date") }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="group in pageOfItems" :key="group.id" class="table-row">
                  <td>{{ group.name }}</td>
                  <td>{{ group.description }}</td>
                  <td>{{ $d(new Date(group.created_at), 'short') }}</td>
                  <td class="text-center">
                    <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                      </template>
                      <b-dropdown-item @click="
                                      $router.push({ path: `/groups/show/${group.id}` })
                                  ">
                        {{ $t("pages.users.display") }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="updateGroupModal(group)">
                        {{ $t("pages.metadata.edit") }}
                      </b-dropdown-item>
                      <b-dropdown-item @click="onDelete(group)">
                        {{ $t("pages.users.delete") }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-center empty-state-container" v-else>
          <div class="row">
            <div class="col-md-3 mx-auto">
              <lottie-animation ref="anim" :animationData="require('@/assets/json/empty-state.json')" :loop="true" />
            </div>
          </div>
          <h4 class="text-center">{{ $t("pages.groups.empty.title") }}</h4>
          <p class="mt-2">{{ $t("pages.groups.empty.text") }}</p>
        </div>
        <div class="text-center">
          <jw-pagination :pageSize="pageSize" :items="groups" @changePage="onChangePage" :labels="labels"
            class="text-center"></jw-pagination>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import managerHelper from "../../../components/manager/mixins/manager";
import { mapActions, mapState } from 'vuex';
import LottieAnimation from "lottie-web-vue";

export default {
  page: {
    title: "groups",
  },
  mixins: [managerHelper],
  components: {
    Layout,
    LottieAnimation
  },
  data() {
    return {
      title: "pages.groups.title",
      group: {
        name: "",
        description: "",
      },
      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },
      name_placeholder: "pages.groups.name_placeholder",
      description_placeholder: "pages.groups.description_placeholder",
      showModal: false,
      isLoading: false,
      updating: false,
      selectedItem: {},
      bool: false,
      pageOfItems: [],
      pageSize: 10,
    };
  },
  computed: {
    ...mapState({
      groups: (state) => state.group.groups,
    }),
    modalTitle() {
      return this.updating ? this.$t('pages.groups.actions.update') : this.$t('pages.groups.actions.create');
    },
  },
  methods: {
      ...mapActions(["allGroups", "createGroup","updateGroup", "deleteGroup"]),
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    closeModal() {
      this.showModal = false;
      this.group = {
        id: null,
        name: "",
        description: "",
      };
      this.updating = false;
      this.selectedItem = {
        id: null,
        name: "",
        description: "",
      };
    },
    updateGroupModal(group) {
      this.showModal = true;
      this.updating = true;
      this.selectedItem = {
        id: group.id,
        name: group.name,
        description: group.description,
      };
    },
    onSubmit() {
      if (this.updating) {
        this.isLoading = true;
        this.updateGroup(this.selectedItem)
          .then((response) => {
            if (response.status === 200) {
              this.isLoading = false;
              this.$toasted.success(this.$t('pages.groups.actions.updated'));
              this.closeModal();
              this.allGroups();
            }
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.isLoading = false;
              this.$toasted.error(this.$t('pages.groups.actions.fillin'));
            } else {
              this.isLoading = false;
              this.$toasted.error(this.$t('pages.unauthorized.error_0'));
            }
          });
      } else {
        this.createGroup(this.group)
          .then((response) => {
            if (response.status === 201) {
              this.isLoading = false;
              this.$toasted.success(this.$t('pages.groups.actions.created'));
              this.closeModal();
              this.allGroups();
            }
          })
          .catch((error) => {
            if (error.response.status === 409) {
              this.isLoading = false;
              this.$toasted.error(this.$t('pages.groups.actions.exists'));
            } else {
              this.isLoading = false;
              this.$toasted.error(this.$t('pages.unauthorized.error_0'));
            }
          });        
      }
    },
    onDelete(group) {
        this.$toasted.clear();
        this.$swal({
          text: this.$t("pages.groups.swal") + ` ${group.name} ?`,
          confirmButtonColor: "#d33",
          confirmButtonText: this.$t("pages.groups.actions.btn.delete"),
        }).then((result) => {
          if (result.value) {
            this.deleteGroup(group.id)
              .then((response) => {
                if (response) {
                  this.$swal(
                    this.$t("pages.groups.actions.confirm"),
                    this.$t("pages.groups.actions.deleted"),
                    "success"
                  ).then(() => {
                    this.isLoading = false;
                  });
                }
              })
              .catch(() => {
                this.$toasted.error(this.$t("pages.groups.actions.impossible"));
              });
          }
        });
    },
  },
  created() {
    this.isLoading = true;
    this.allGroups().then(() => {
      this.isLoading = false;
    });
  },
};
</script>


